import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import { BASE_URL, SOCIAL_FETCH, SOCIAL_EDIT, M_POST } from '@/utils/api';

@Module({ name: 'social' })
export default class Social extends VuexModule {
  socialList: any = [];

  @Mutation
  mutateSocial(social: any) {
    this.socialList = social;
  }

  @Action({ commit: 'mutateSocial', rawError: true })
  async FetchSocial(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + SOCIAL_FETCH,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch social failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch social failed');
    }
  }

  @Action({ rawError: true })
  async EditSocial(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + SOCIAL_EDIT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Edit social failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Edit social failed');
    }
  }
}
